import _defineProperty from "/var/jenkins_home/workspace/web_bieyangapp_review_page/product-search/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React, { memo } from 'react';
import { withNativeProps } from '../../utils/native-props';
import classNames from 'classnames';
import { mergeProps } from '../../utils/with-default-props';
var classPrefix = "adm-page-indicator";
var defaultProps = {
  color: 'primary',
  direction: 'horizontal'
};
export var PageIndicator = memo(function (p) {
  var props = mergeProps(defaultProps, p);
  var dots = [];

  for (var i = 0; i < props.total; i++) {
    dots.push(React.createElement("div", {
      key: i,
      className: classNames("".concat(classPrefix, "-dot"), _defineProperty({}, "".concat(classPrefix, "-dot-active"), props.current === i))
    }));
  }

  return withNativeProps(props, React.createElement("div", {
    className: classNames(classPrefix, "".concat(classPrefix, "-").concat(props.direction), "".concat(classPrefix, "-color-").concat(props.color))
  }, dots));
});